import {
  IAddNoteServiceRequestPayload,
  INoteData,
  INoteFormConfig,
  IPreparedNoteApiData,
  IRawNoteFormData,
} from 'src/SharedCustomHooks/UseNotesAPI/types';

const convertAppointmentToUTC = (appointment: any) => {
  if (!appointment) return '';

  const date = new Date(appointment.date);
  const time = new Date(appointment.time);
  const hours = time.getHours();
  const minutes = time.getMinutes();

  date.setHours(hours);
  date.setMinutes(minutes);

  return date;
};

export const prepareCreateNoteDataForAPI = (
  noteData: IRawNoteFormData,
  referenceId: string,
  user: any,
  noteConfig: any
): any => {
  // Enhance note with author and creation metadata.
  const enhancedNote: INoteData = {
    ...noteData,
    author: {
      id: user.id,
      firstName: user.firstName ?? user.firstname,
      lastName: user.lastName ?? user.lastname,
    },
    createdAt: new Date(),
  };

  const apiData: IPreparedNoteApiData = {
    ItemId: referenceId,
    Name: noteConfig.noteName || 'NOTES',
    Type: noteConfig.noteType || 'NOTES',
    ItemType: noteConfig.ItemType,
    Data: JSON.stringify(enhancedNote).toString(), // Note: Capital 'D' for creation
    UserId: user.id,
    visibilityType: noteData.visibilityType,
    noteVisibleToHomeownerOccupantRealtor:
      noteData.noteVisibleToHomeownerOccupantRealtor,
  };

  if (noteData.appointment) {
    apiData.ReminderDate = convertAppointmentToUTC(noteData.appointment);
  }

  return apiData;
};

export const prepareUpdateNoteDataForAPI = (
  noteData: IRawNoteFormData,
  referenceId: string,
  user: any,
  noteConfig: INoteFormConfig,
  ticketNumber: any = null
): IAddNoteServiceRequestPayload => {
  // Base API payload structure for updates.
  const apiData: any = {
    ItemId: referenceId,
    id: noteData.id,
    Name: noteConfig.noteName || 'NOTES',
    Type: noteConfig.noteType || 'NOTES',
    ItemType: noteConfig.ItemType,
    data: JSON.stringify(noteData).toString(), // Note: lowercase 'd' for updates
    UserId: user.id,
    visibilityType: noteData.visibilityType,
    noteVisibleToHomeownerOccupantRealtor:
      noteData.noteVisibleToHomeownerOccupantRealtor,
  };

  if (ticketNumber) {
    apiData.TicketNumber = ticketNumber.toString();
  }

  if (noteData.appointment) {
    apiData.ReminderDate = convertAppointmentToUTC(noteData.appointment);
  }

  return apiData;
};
